export var popupEntranceAnimateBasic = {
	none: { label: "None", value: "" },
	backInDown: { label: "backInDown", value: "backInDown" },
	backInLeft: { label: "backInLeft", value: "backInLeft" },
	backInRight: { label: "backInRight", value: "backInRight" },
	backInUp: { label: "backInUp", value: "backInUp" },
	bounceIn: { label: "bounceIn", value: "bounceIn" },
	bounceInDown: {
		label: "bounceInDown",
		value: "bounceInDown",

	},
	bounceInLeft: {
		label: "bounceInLeft",
		value: "bounceInLeft",

	},
	bounceInRight: {
		label: "bounceInRight",
		value: "bounceInRight",

	},
	bounceInUp: { label: "bounceInUp", value: "bounceInUp" },
	fadeIn: { label: "fadeIn", value: "fadeIn" },
	fadeInDown: { label: "fadeInDown", value: "fadeInDown" },
	fadeInDownBig: {
		label: "fadeInDownBig",
		value: "fadeInDownBig",

	},
	fadeInLeft: { label: "fadeInLeft", value: "fadeInLeft" },
	fadeInLeftBig: {
		label: "fadeInLeftBig",
		value: "fadeInLeftBig",

	},
	fadeInRight: { label: "fadeInRight", value: "fadeInRight" },
	fadeInRightBig: {
		label: "fadeInRightBig",
		value: "fadeInRightBig",

	},
	fadeInUp: { label: "fadeInUp", value: "fadeInUp" },
	fadeInUpBig: { label: "fadeInUpBig", value: "fadeInUpBig" },
	fadeInTopLeft: {
		label: "fadeInTopLeft",
		value: "fadeInTopLeft",

	},
	fadeInTopRight: {
		label: "fadeInTopRight",
		value: "fadeInTopRight",

	},
	fadeInBottomRight: {
		label: "fadeInBottomRight",
		value: "fadeInBottomRight",

	},
	fadeInBottomLeft: {
		label: "fadeInBottomLeft",
		value: "fadeInBottomLeft",

	},
	rotateIn: { label: "rotateIn", value: "rotateIn" },
	rotateInDownLeft: {
		label: "rotateInDownLeft",
		value: "rotateInDownLeft",

	},
	rotateInDownRight: {
		label: "rotateInDownRight",
		value: "rotateInDownRight",

	},
	rotateInUpLeft: {
		label: "rotateInUpLeft",
		value: "rotateInUpLeft",

	},
	rotateInUpRight: {
		label: "rotateInUpRight",
		value: "rotateInUpRight",

	},
	zoomIn: { label: "zoomIn", value: "zoomIn" },
	zoomInDown: { label: "zoomInDown", value: "zoomInDown" },
	zoomInLeft: { label: "zoomInLeft", value: "zoomInLeft" },
	zoomInRight: { label: "zoomInRight", value: "zoomInRight" },
	zoomInUp: { label: "zoomInUp", value: "zoomInUp" },
	slideInDown: { label: "slideInDown", value: "slideInDown" },
	slideInLeft: { label: "slideInLeft", value: "slideInLeft" },
	slideInRight: {
		label: "slideInRight",
		value: "slideInRight",

	},
	slideInUp: { label: "slideInUp", value: "slideInUp" },
};
